import {
  IRequetTableHistorico,
  IRequetTableHistoricoPorSupervisor,
} from "../../Interfaces/IListaVerificacion";
import { _formatDate } from "../helpers/dateHelpers";

export const InitialTableHistorico: IRequetTableHistorico = {
  equipoId: null,
  equipoModeloId: null,
  estadoId: null,
  tipoEquipoId: null,
  guardia: null,
  supervisorId: null,
  fechaFin: _formatDate(new Date(), ","),
  fechaInicio: _formatDate(new Date(), ","),
  search: "",
  skip: 0,
  take: 40,
};

export const InitialTableHistoricoPorSupervisor: IRequetTableHistoricoPorSupervisor =
  {
    equipoId: null,
    equipoModeloId: null,
    estadoId: null,
    tipoEquipoId: null,
    fechaFin: "",
    fechaInicio: "",
    search: "",
    skip: 0,
    take: 50,
  };
